import React from "react";
import Sentry from "react-activity/lib/Sentry";

import {
	getBaseRate,
	getMerchant,
	getAccessControl,
} from "../../../libs/functions";

import ManageMerchantDetails from "./manage/ManageMerchantDetails";
import ManageMerchantIdentification from "./manage/ManageMerchantIdentification";
import ManageMerchantRatesv2 from "./manage/ManageMerchantRatesv2";
import ManageMerchantGateway from "./manage/ManageMerchantGateway";
import ManageMerchantAdhocPayments from "./manage/ManageMerchantAdhocPayments";

class ViewMerchantModal extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			merchant: null,
			baseRate: null,
			master: false,
		};
	}

	componentDidMount = async () => {
		this.setState({ master: (await getAccessControl()) === "master" });
		this.retrieveMerchant();
	};

	componentDidUpdate(prevProps, prevState) {
		if (
			JSON.stringify(prevProps.merchant) !== JSON.stringify(this.props.merchant)
		) {
			this.retrieveMerchant();
		}
	}

	retrieveMerchant = async () => {
		if (this.props?.merchant?.id) {
			this.setState({ merchant: null });
			const merchant = await getMerchant({
				merchantId: this.props.merchant.id,
			});
			this.setState({ merchant });
			this.retrieveBaseRate(merchant);
		}
	};

	retrieveBaseRate = async (merchant) => {
		const { resellers } = this.props;
		const target = resellers.find(
			(reseller) => reseller._id === merchant.reseller._id
		);
		// let type = "base";
		// if (target && target.commissionType) type = target.commissionType;

		const baseRate = await getBaseRate(target?._id);
		this.setState({ baseRate });
	};

	render() {
		const {
			id,
			gateway,
			MDRTypes,
			master,
			resellers,
			baseToAdhocPaymentMethods,
		} = this.props;
		const { baseRate, merchant } = this.state;

		return (
			<div id={id} className="uk-modal-full" bg-close="false" uk-modal="">
				<div className="uk-modal-dialog">
					<button
						className="uk-modal-close-full uk-close-large"
						type="button"
						uk-close=""
					/>
					{merchant && (
						<div className="uk-padding" style={{ paddingTop: 30 }}>
							<h3>
								<span className="uk-flex uk-flex-middle">
									<i
										className="uk-margin-small-right form-header-icon"
										uk-icon="icon: fa-solid-store-alt"
									/>
									{merchant.name}
									{!merchant.isArchive && master && (
										<button
											className="uk-margin-left uk-icon-button uk-button-danger"
											uk-icon="icon: fa-solid-archive; ratio: 0.5"
											type="button"
											onClick={() =>
												this.props.archiveMerchant(
													merchant.id,
													"Archived",
													false
												)
											}
										/>
									)}
								</span>
							</h3>
							<div className="uk-margin-top uk-grid-divider uk-grid">
								<div className="main-info uk-flex uk-flex-column uk-width-2-5@m">
									<ManageMerchantDetails
										merchant={merchant}
										readOnly={merchant.isArchive || !master}
										retrieveMerchants={this.retrieveMerchant}
										gateway={gateway}
										resellers={resellers}
									/>
									<ManageMerchantIdentification
										merchant={merchant}
										readOnly={merchant.isArchive || !master}
										retrieveMerchants={this.retrieveMerchant}
										gateway={gateway}
										master={master}
									/>
								</div>
								<div className="uk-width-3-5@m">
									<div className="uk-flex uk-flex-column">
										{merchant.paymentGateway && (
											<ManageMerchantGateway
												merchant={{ id: merchant.id, name: merchant.name }}
												accepted={merchant.paymentGateway}
												readOnly={merchant.isArchive || !master}
												retrieveMerchants={this.retrieveMerchant}
												MDRTypes={MDRTypes}
												gateway={gateway}
											/>
										)}
										{baseToAdhocPaymentMethods && MDRTypes && (
											<ManageMerchantAdhocPayments
												merchant={merchant}
												readOnly={merchant.isArchive || !master}
												retrieveMerchants={this.retrieveMerchant}
												baseToAdhocPaymentMethods={baseToAdhocPaymentMethods}
												MDRTypes={MDRTypes}
											/>
										)}
										{baseRate && merchant.rates && (
											<ManageMerchantRatesv2
												merchant={{ id: merchant.id, name: merchant.name }}
												MDRTypes={MDRTypes}
												gateway={gateway}
												rates={merchant.rates}
												baseRate={baseRate}
												retrieveMerchants={this.retrieveMerchant}
												master={master}
												readOnly={merchant.isArchive || !master}
											/>
										)}
									</div>
								</div>
							</div>
						</div>
					)}
					{!merchant && (
						<Sentry
							className="uk-position-center"
							size={50}
							color="#E5732E"
							animating={true}
						/>
					)}
				</div>
			</div>
		);
	}
}

export default ViewMerchantModal;
